export default {
  SUMMARY_INFO: 'SUMMARY_INFO',
  REPAYMENT_SCHEDULE: 'REPAYMENT_SCHEDULE',
  TRANSACTIONS: 'TRANSACTIONS',
  DOCUMENT: 'DOCUMENT',
  COLLATERAL_INFO: 'COLLATERAL_INFO',
  NOTES: 'NOTES',
};
